export default function({ state, commit, dispatch, getters }, query) {
    let providerList = [], providerPatientsList = []
    // If state id is set (provider is chosen), only search that provider and get the patient list for that provider
    // else search all providers by making the providerList and get the patient list for all providers
    // Also get 
    if(state.id) {
        providerList.push(state.id)
        let providerObj = getters.getProviderPatientList.find((provider) => provider.id === state.id)
        providerPatientsList = providerObj ? providerObj.patient : []
    }
    else {
        providerList = state.providers.map((provider) => provider.provider)
        providerPatientsList = getters.getAllProviderPatientList
    }
        

    return Promise.all([
        ...providerList
            .map((provider) => {
                try {
                    return dispatch('get', { url: '/provider/' + provider + '/search', query }, { root: true })
                        .then((response) => ({ provider, patients: response}))
                        .catch((error) => {
                            console.error('Error searching for patients', error)
                            return Promise.resolve({ provider, patients: [] })
                        })
                } catch (error) {
                    console.error('Error searching for patients', error)
                    return Promise.resolve({ provider, patients: [] })
                }
            })
    ])
    .then((response) => {

        let allPatients = response.flatMap((patientList) => 
            patientList.patients.map(patient => ({...patient, providerId: [patientList.provider]}))
        )
        // Remove duplicates from allPatients by id
        // key in the object of Arrays
        const key = 'id'
        // create a patientObj
        const patientObj = {}
        // loop over the array
        for (const item of allPatients) {
            // Check if key does not exist in patientObj then update the object from providerPatientsList and allPatients
            if (!patientObj[item[key]]) {
                // Get the patient from providerPatientsList
                let patientFromProviderList = providerPatientsList.find((patient) => patient.id === item[key])
                // Get the patient from allPatients
                let patientFromAllPatients = allPatients.find((patient) => patient.id === item[key])
                // Merge the two patients
                patientObj[item[key]] = {
                    ...(patientFromProviderList ? patientFromProviderList : {}),
                    ...(patientFromAllPatients ? patientFromAllPatients : {})
                }
            }
        }
        // create the final Array with values from patientObj
        const uniquePatients = Object.values(patientObj)
        return uniquePatients
    })
}
